import { useAiProductDescription } from '@/hooks/useAiProductDescription';
import { ProductGrid, type ProductGridMode } from './ProductGrid';
// import { ProductsSummaryBar } from './ProductsSummaryBar';

/**
 * Full-page layout for the products steps.
 *
 * `default` is the classic step 2. The guided entry uses `catalog` for its
 * step 2 (browse and pick from the whole range) and `overview` for its step
 * 3 (only the picked products, with prices).
 */
export function ProductsStepLayout({
  mode = 'default',
}: {
  mode?: ProductGridMode;
}) {
  useAiProductDescription();

  return (
    <main className="flex-1 overflow-auto bg-[var(--paper)]">
      <div className="dc-step w-full px-6 py-6">
        {/* <ProductsSummaryBar /> */}
        <div className="dc-step-content mt-5">
          <ProductGrid variant="full" mode={mode} />
        </div>
      </div>
    </main>
  );
}
